import * as React from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  IconButton,
  InputBase,
  Paper,
  Badge,
  Avatar,
  Button,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MenuIcon from "@mui/icons-material/Menu";

import { Colors } from "../utils/Colors";

export default function HeaderBar({ onOpenLeft, onOpenRight }) {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: Colors.bg.paper,
        color: Colors.text.header,
        borderBottom: `1px solid ${Colors.border.light}`,
      }}
    >
      <Toolbar
        sx={{
          minHeight: 72,
          px: { xs: 1.5, sm: 2.5 },
          gap: { xs: 1.25, sm: 2 },
        }}
      >
        <IconButton onClick={onOpenLeft} sx={{ borderRadius: 2 }}>
          <MenuIcon />
        </IconButton>

        <Box sx={{ flex: 1, display: "flex" }}>
          <Paper
            component="form"
            onSubmit={(e) => e.preventDefault()}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              px: 1.5,
              height: 42,
              borderRadius: 2,
              border: `1px solid ${Colors.border.input}`,
              boxShadow: "none",
              width: "100%",
              maxWidth: { xs: "100%", sm: 520, md: 560 },
            }}
          >
            <SearchIcon sx={{ color: Colors.text.title }} />
            <InputBase
              placeholder="Search patient name or ID"
              sx={{
                width: "100%",
                fontSize: 14,
                color: Colors.text.header,
                "& input::placeholder": {
                  color: Colors.text.placeholder,
                  opacity: 1,
                },
              }}
            />
          </Paper>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton
            sx={{
              borderRadius: 2,
              "&:hover": { bgcolor: Colors.bg.hover },
            }}
          >
            <Badge
              variant="dot"
              overlap="circular"
              sx={{
                "& .MuiBadge-badge": {
                  bgcolor: Colors.status.warning,
                  color: Colors.status.warning,
                  boxShadow: `0 0 0 2px ${Colors.bg.paper}`,
                },
              }}
            >
              <NotificationsNoneIcon sx={{ color: Colors.text.muted }} />
            </Badge>
          </IconButton>

          <Button
            onClick={onOpenRight}
            sx={{
              textTransform: "none",
              p: 0.75,
              borderRadius: 2,
              color: "inherit",
              "&:hover": { bgcolor: Colors.bg.hover },
            }}
            startIcon={<Avatar sx={{ width: 36, height: 36 }} />}
            endIcon={<KeyboardArrowDownIcon />}
          >
            <Box sx={{ textAlign: "left", lineHeight: 1.1 }}>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: 14,
                  color: Colors.text.title,
                }}
              >
                Fludee Admin
              </Typography>
              <Typography
                sx={{
                  fontSize: 12,
                  color: Colors.text.sub,
                }}
              >
                Super Admin
              </Typography>
            </Box>
          </Button>
        </Box>
      </Toolbar>

      <Box
        sx={{
          height: 10,
          bgcolor: Colors.brand.accentBar,
          borderTop: `1px solid ${Colors.border.topLine}`,
        }}
      />
    </AppBar>
  );
}